<template>
  <el-container>
    <el-header>
      <Header></Header>
    </el-header>
    <el-container class="container" >
      <el-container style="display:flex;flex-flow:row">
      <el-main>
        <router-view />
      </el-main>
      </el-container>
    </el-container>
    <Footer></Footer>
  </el-container>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'Layout',
  components: { Header, Footer }
}
</script>
<style>
.el-header {
    height: auto !important;
    padding: 0 !important;
    color: #fff;
    background: #011e41;
    text-align: center;
}
.el-main {
    padding: 0 !important;
    box-sizing: border-box;
    /* margin: 0; */
}
.el-main >div {
  height: auto;
}
.container{
    padding: 0;
    margin: 0;
}
</style>
